import { Dropdown } from '@watcherr/ui';
import * as React from 'react';
import styles from './ChartFilter.module.css';
interface FilterValue {
  value: string;
  label: string;
}

interface ChartFilterProps {
  value: string;
  placeholder?: string;
  items: FilterValue[];
  onChange: (value: string) => void;
}

const ChartFilter: React.FC<ChartFilterProps> = ({
  value,
  items,
  onChange,
  placeholder = 'Select value',
}) => {
  const handleSelectChange = React.useCallback(
    (value) => () => {
      onChange(value);
    },
    [onChange]
  );
  const selected = React.useMemo(
    () => items.find((i) => i.value === value),
    [value, items]
  );

  return (
    <Dropdown
      containerClassName={styles.ChartFilter}
      entryClassName={styles.ChartFilter}
      name={selected ? selected.label : placeholder}
      options={items.map((item) => ({
        label: item.label,
        onClick: handleSelectChange(item.value),
      }))}
    />
  );
};
export default ChartFilter;
